export default function debounce(fn, interval = 0) {
  let lastCallAt;
  let timeout;
  let running = false;
  let nextArgs;

  return function debounced(...args) {
    const currentTime = new Date().getTime();
    const isLeading = !lastCallAt || currentTime - lastCallAt > interval;

    lastCallAt = currentTime;

    function onFinish() {
      running = false;
      if (nextArgs) {
        // eslint-disable-next-line no-use-before-define
        run(...nextArgs);
        nextArgs = null;
      }
    }

    function run(...currentArgs) {
      running = true;
      Promise.resolve(fn(...currentArgs)).then(onFinish, onFinish);
    }

    if (running) {
      nextArgs = args;
      return;
    }

    if (timeout) clearTimeout(timeout);

    if (isLeading) {
      run(...args);
    } else {
      timeout = setTimeout(() => {
        run(...args);
        timeout = null;
      }, interval);
    }
  };
}
